import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
import DefaultResolver from 'flarum/common/resolvers/DefaultResolver';
import ReviewsProfileSection from './components/ReviewsProfileSection';
/**
 * Aba "Reviews" no perfil (avaliacoes que o usuario escreveu), ao lado de
 * Posts/Discussoes e da aba Vendedor. Mostra a contagem na frente, como
 * discussions/posts. Separada da pagina de vendedor (que mostra as recebidas).
 * Mesmo padrao de rota/resolver do sellerProfileIntegration (resolver proprio +
 * troca tardia do component quando o avocado carrega).
 */
const ROUTE = 'marketplace.user_reviews';
class CoreReviewsUserPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    const username = m.route.param('username');
    const cached = app.store.all('users').find(u => (u.slug?.() === username || u.username?.() === username) && u.joinTime?.());
    if (cached) {
      this.user = cached;
      return;
    }
    app.store.find('users', username, {
      bySlug: true
    }).then(u => {
      this.user = u;
      if (u?.displayName) app.setTitle(u.displayName());
      m.redraw();
    }).catch(() => m.redraw());
  }
  content() {
    return m(ReviewsProfileSection, {
      user: this.user
    });
  }
}
export default function addReviewsProfileTab() {
  const resolver = new DefaultResolver(CoreReviewsUserPage, ROUTE);
  app.routes[ROUTE] = {
    path: '/u/:username/reviews',
    resolver
  };
  flarum.reg.onLoad('ramon-avocado', 'forum/components/UserProfilePage', mod => {
    const sample = mod?.AvocadoUserPostsPage;
    if (!sample) return;
    const Base = Object.getPrototypeOf(sample);
    if (typeof Base !== 'function') return;
    class AvocadoReviewsUserPage extends Base {
      content() {
        return m(ReviewsProfileSection, {
          user: this.user
        });
      }
    }
    resolver.component = AvocadoReviewsUserPage;
  });

  // Aba "Reviews" — so quando o usuario tem avaliacoes escritas. Contagem na
  // frente do rotulo, como Posts/Discussoes.
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user || typeof user.attribute !== 'function') return;
    const count = Number(user.attribute('marketplaceReviewsCount') || 0);
    if (count <= 0) return;
    const username = typeof user.slug === 'function' ? user.slug() : user.username();
    items.add('marketplace-reviews', LinkButton.component({
      href: app.route(ROUTE, {
        username
      }),
      icon: 'fas fa-star'
    }, [app.translator.trans('ramon-marketplace.forum.user_reviews.tab'), ' ', m('span.Button-badge', count)]), 45);
  });
}